define("shared/components/shared/ui/report/settings-wrapper", ["exports", "@ember/component", "@ember/object", "@ember/runloop", "@ember/service", "@ember/utils", "@glimmer/component", "@latermedia/ember-later-analytics/utils", "later/errors/credentials", "@ember/template-factory"], function (_exports, _component, _object, _runloop, _service, _utils, _component2, _utils2, _credentials, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _dec, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/runloop",0,"@ember/service",0,"@ember/utils",0,"@glimmer/component",0,"@latermedia/ember-later-analytics/utils",0,"later/errors/credentials",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div {{did-insert this.fetchRecentReport}}>
    {{yield this.report this.reportStatus this.reportActions}}
  </div>
  */
  {
    "id": "Y7uA5mZ9",
    "block": "[[[11,0],[4,[38,0],[[30,0,[\"fetchRecentReport\"]]],null],[12],[1,\"\\n  \"],[18,1,[[30,0,[\"report\"]],[30,0,[\"reportStatus\"]],[30,0,[\"reportActions\"]]]],[1,\"\\n\"],[13]],[\"&default\"],false,[\"did-insert\",\"yield\"]]",
    "moduleName": "shared/components/shared/ui/report/settings-wrapper.hbs",
    "isStrictMode": false
  });
  let SettingsWrapperComponent = _exports.default = (_dec = (0, _service.inject)('social/instagram-business'), (_class = class SettingsWrapperComponent extends _component2.default {
    constructor() {
      var _this;
      super(...arguments);
      _this = this;
      _initializerDefineProperty(this, "auth", _descriptor, this);
      _initializerDefineProperty(this, "credentialStatus", _descriptor2, this);
      _initializerDefineProperty(this, "errors", _descriptor3, this);
      _initializerDefineProperty(this, "performanceReport", _descriptor4, this);
      _initializerDefineProperty(this, "router", _descriptor5, this);
      _initializerDefineProperty(this, "subscriptions", _descriptor6, this);
      _initializerDefineProperty(this, "instagramBusiness", _descriptor7, this);
      _defineProperty(this, "createReport", () => {
        this.performanceReport.createReport();
      });
      _defineProperty(this, "manuallyUpdateReport", () => {
        this.performanceReport.manuallyUpdateReport();
      });
      _defineProperty(this, "toggleReportAutoUpdate", () => {
        this.performanceReport.toggleReportAutoUpdate();
      });
      _defineProperty(this, "toggleEngagementIndustryBenchmark", () => {
        this.performanceReport.toggleEngagementIndustryBenchmark();
      });
      _defineProperty(this, "toggleReport", async () => {
        await this.performanceReport.toggleReport();
      });
      _defineProperty(this, "connectInstagramBusinessAccount", () => {
        this.instagramBusiness.refreshBusinessAccountEndpoint(this.performanceReport.socialProfile).catch(error => {
          if (error instanceof _credentials.CredentialsNotFoundError) {
            error.resolve.call(this, this.performanceReport.socialProfile);
          } else if (error instanceof Error || typeof error === 'string') {
            this.errors.log(error);
          } else {
            this.errors.log(new Error('Unknown Refresh Instagram Business Account Error'), error);
          }
        });
        this.credentialStatus.checkBrokenProfiles();
      });
      _defineProperty(this, "routeToChangeIndustry", event => {
        event.preventDefault();
        this.router.transitionTo('account.groups.group.social_profiles.edit', this.auth.currentGroup.id, this.args.socialProfile.id, {
          queryParams: {
            tab: 'industry'
          }
        });
      });
      _defineProperty(this, "setIsLoadingPreview", function () {
        let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        (0, _runloop.later)(() => {
          _this.performanceReport.setIsLoadingPreview(state);
        }, 1500);
      });
    }
    get report() {
      return this.performanceReport.analyticsPerformanceReport;
    }
    get showCreateReport() {
      return !this.isReportPresent || this.isReportDisabled;
    }
    get isReportPresent() {
      return this.performanceReport.isReportPresent;
    }
    get isReportDisabled() {
      return this.performanceReport.isReportDisabled;
    }
    get isReportBeingGenerated() {
      return this.performanceReport.isReportBeingGenerated;
    }
    get isLoadingReport() {
      return this.performanceReport.isLoading;
    }
    get isMissingIndustry() {
      return (0, _utils.isBlank)(this.args.socialProfile?.industry);
    }
    get reportViews() {
      return this.performanceReport.reportViews || 0;
    }
    get isUpdating() {
      return this.performanceReport.isUpdating;
    }
    get isAutoUpdateEnabled() {
      return this.report?.autoUpdateEnabled || false;
    }
    get isBenchmarkEngagementEnabled() {
      return this.report?.benchmarkEngagementEnabled || false;
    }
    get canManualUpdate() {
      return !this.performanceReport.reportRecentlyUpdated && !this.performanceReport.isUpdating;
    }
    get showUpsell() {
      const planName = this.subscriptions.planName || '';
      return ['Free', 'Basics', 'Starter'].includes(planName) && !this.subscriptions.hasActiveTrial && !this.auth.currentUserModel.admin;
    }
    get showTrialUpSell() {
      const planName = this.subscriptions.planName || '';
      return ['Free', 'Basics', 'Starter'].includes(planName) && this.subscriptions.hasActiveTrial && !this.auth.currentUserModel.admin;
    }
    get page() {
      return this.performanceReport.page;
    }
    get preview() {
      const engagementSignificantDigits = 2;
      const preview = {};
      if ((0, _utils.isPresent)(this.report?.preview?.profile_average_engagement)) {
        const profileMeta = (0, _utils2.convertNumberToMeta)(Number(this.report?.preview?.profile_average_engagement) * 100, true, null, false, false);
        preview.profileAverageEngagement = (0, _utils2.convertMetaToString)(profileMeta, true, engagementSignificantDigits, false);
      }
      if ((0, _utils.isPresent)(this.report?.preview?.industry_average_engagement)) {
        const industryMeta = (0, _utils2.convertNumberToMeta)(Number(this.report?.preview?.industry_average_engagement) * 100, true, null, false, false);
        preview.industryAverageEngagement = (0, _utils2.convertMetaToString)(industryMeta, true, engagementSignificantDigits, false);
      }
      return preview;
    }
    get reportStatus() {
      return {
        isReportPresent: this.isReportPresent,
        isReportDisabled: this.isReportDisabled,
        isReportBeingGenerated: this.isReportBeingGenerated,
        isLoadingReport: this.isLoadingReport,
        isUpdating: this.isUpdating,
        isMissingIndustry: this.isMissingIndustry,
        hasMissingProfessionalPermission: this.performanceReport.hasMissingProfessionalPermission,
        canManualUpdate: this.canManualUpdate,
        isAutoUpdateEnabled: this.report?.autoUpdateEnabled || false,
        isBenchmarkEngagementEnabled: this.isBenchmarkEngagementEnabled,
        reportViews: this.reportViews,
        preview: this.preview,
        isLoadingPreview: this.performanceReport.isLoadingPreview,
        reportUrl: this.report?.url,
        showCreateReport: this.showCreateReport,
        showUpsell: this.showUpsell,
        showTrialUpsell: this.showTrialUpSell,
        page: this.page
      };
    }
    get reportActions() {
      return {
        createReport: this.createReport,
        manuallyUpdateReport: this.manuallyUpdateReport,
        toggleReportAutoUpdate: this.toggleReportAutoUpdate,
        toggleEngagementIndustryBenchmark: this.toggleEngagementIndustryBenchmark,
        toggleReport: this.toggleReport,
        connectInstagramBusinessAccount: this.connectInstagramBusinessAccount,
        routeToChangeIndustry: this.routeToChangeIndustry,
        setIsLoadingPreview: this.setIsLoadingPreview
      };
    }
    fetchRecentReport() {
      this.performanceReport.fetchRecentReport();
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "credentialStatus", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "performanceReport", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "subscriptions", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "instagramBusiness", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "fetchRecentReport", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "fetchRecentReport"), _class.prototype)), _class));
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, SettingsWrapperComponent);
});